import { render, staticRenderFns } from "./NoIcons.vue?vue&type=template&id=6b72363c&scoped=true&"
import script from "./NoIcons.vue?vue&type=script&lang=js&"
export * from "./NoIcons.vue?vue&type=script&lang=js&"
import style0 from "./NoIcons.vue?vue&type=style&index=0&id=6b72363c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b72363c",
  null
  
)

export default component.exports